var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{staticClass:"transaction-avatar elevation-0",attrs:{"color":_vm.avatarProps.color}},[(_vm.showIcon)?_c('v-icon',[_vm._v(_vm._s(_vm.avatarProps.icon))]):_c('v-progress-circular',{attrs:{"size":"28","indeterminate":"","color":"primary"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }